module.exports = __webpack_public_path__ + "img/var_03_base.5c3f3d77.png";